
    import './styles.scoped.css';
    export default {
  "content": "awsui_content_vjswe_1y1f6_97",
  "button": "awsui_button_vjswe_1y1f6_101",
  "variant-normal": "awsui_variant-normal_vjswe_1y1f6_152",
  "is-activated": "awsui_is-activated_vjswe_1y1f6_165",
  "variant-icon": "awsui_variant-icon_vjswe_1y1f6_192",
  "variant-modal-dismiss": "awsui_variant-modal-dismiss_vjswe_1y1f6_192",
  "variant-flashbar-icon": "awsui_variant-flashbar-icon_vjswe_1y1f6_192",
  "variant-inline-icon": "awsui_variant-inline-icon_vjswe_1y1f6_210",
  "disabled": "awsui_disabled_vjswe_1y1f6_228",
  "variant-primary": "awsui_variant-primary_vjswe_1y1f6_236",
  "variant-link": "awsui_variant-link_vjswe_1y1f6_320",
  "variant-inline-link": "awsui_variant-inline-link_vjswe_1y1f6_572",
  "variant-breadcrumb-group": "awsui_variant-breadcrumb-group_vjswe_1y1f6_827",
  "variant-menu-trigger": "awsui_variant-menu-trigger_vjswe_1y1f6_915",
  "button-no-text": "awsui_button-no-text_vjswe_1y1f6_999",
  "button-no-wrap": "awsui_button-no-wrap_vjswe_1y1f6_1003",
  "full-width": "awsui_full-width_vjswe_1y1f6_1006",
  "icon-left": "awsui_icon-left_vjswe_1y1f6_1025",
  "icon-right": "awsui_icon-right_vjswe_1y1f6_1030",
  "icon": "awsui_icon_vjswe_1y1f6_1025"
};
  